import styled from 'styled-components';

export const ContainerAlertErrorMessage = styled.div`
  position: ${({ position }) => position ?? 'initial'};
  top: ${({ top }) => top ?? '0'}px;
  left: ${({ left }) => left ?? '0'}px;
  right: ${({ right }) => right ?? '0'}px;

  font-size: 16px;
  background-color: #fee2e2;
  display: flex;
  justify-content: ${({ textAlign }) => textAlign ?? 'center'};
  align-items: center;

  box-sizing: border-box;
  color: #b91c1c;
  border-radius: 8px;
  margin-bottom: ${({ marginBottom }) => marginBottom ?? '0'}px;

  margin-top: ${({ marginTop }) => marginTop ?? '0'}px;

  @media (max-width: 768px) {
    padding: 12px;

    svg {
      width: 80px;
    }
  }
`;
